import React, { useState, useEffect } from 'react';

interface DateTimeDisplayProps {
  language: string;
  isVisible: boolean;
}

const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({ language, isVisible }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const updateDateTime = () => {
      setCurrentDate(new Date());
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatDate = (date: Date, lang: string): string => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };

    return lang === 'vi' 
      ? date.toLocaleDateString('vi-VN', options) 
      : date.toLocaleDateString('en-US', options);
  };

  return (
    <div
      className={`fixed bottom-8 right-8 z-50 hidden md:block transition-all duration-500 ease-in-out ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      <span className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-wide uppercase drop-shadow-sm">
        {formatDate(currentDate, language)}
      </span>
    </div>
  );
};

export default DateTimeDisplay;